import {getApp, getApps, initializeApp} from 'firebase/app';

const webEnvironment = (process.env.ENV || 'dev').toLowerCase();
const firebaseConfigByEnv = {
  dev: 'dev',
  development: 'dev',
  prod: 'prod',
  production: 'prod',
  stage: 'staging',
  staging: 'staging',
};
const firebaseConfigEnv = firebaseConfigByEnv[webEnvironment] || 'dev';

const firebaseConfigs = {
  dev: require('../../src/asset/analytic/web/config/dev/firebase-config.json'),
  prod: require('../../src/asset/analytic/web/config/prod/firebase-config.json'),
  staging: require('../../src/asset/analytic/web/config/staging/firebase-config.json'),
};

const firebaseConfig =
  firebaseConfigs[firebaseConfigEnv] || firebaseConfigs.dev;

export const firebaseApp = getApps().length
  ? getApp()
  : initializeApp(firebaseConfig);
export const app = firebaseApp;
export const firebase = {app: () => firebaseApp};

export const getFirebaseAnalytics = async () => null;

export const getFirebaseApp = () => firebaseApp;
export {getApp, initializeApp};
export default firebaseApp;
